import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

interface InformationCardContentTopSite {
  description: string;
  descriptionNoData: string;
  id: string;
}

const InformationCardContentTopSite: React.FC<InformationCardContentTopSite> = ({ description, id, descriptionNoData }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const pathSegment = location.pathname.split('/')[1];

  const kpi = useSelector((state: any) => state.kpi);
  const metadata = useSelector((state: any) => state.metadata);
  
  // Determine entity type based on path
  const entity = pathSegment?.includes('member') ? 'Member' : 'Community';
  
  // Get the correct ranking data based on entity type
  const rankingData = entity === 'Community' 
    ? kpi?.communityRanking?.economicsRanking
    : kpi?.memberRanking?.economicsRanking;

  // if ( !rankingData || rankingData?.length === 0 ) { return null }

  // Get the top site from the rankings
  const topSiteRanking = rankingData?.[0]?.rankings?.[0]?.site?.[0];
  
  // Get the site details from metadata by matching siteId
  const sitesList = (metadata?.entities as any)?.site;
  const topSiteDetails = sitesList?.find((site: any) => site.siteId === topSiteRanking?.siteId);
  const siteName = topSiteDetails?.siteName || topSiteRanking?.siteName;

  return (
    

    ( !rankingData || rankingData?.length === 0 )
    ? (
      <span key={`${id}-label_2`} className="paragraph">
        {t(descriptionNoData)}
      </span>
    ) : (
      <>
        <span key={`${id}-label_1`} className="paragraph" >
          { siteName || '-.-' }
        </span>
        <span key={`${id}-label_2`} className="paragraph">
          {' '}{t(description)}
        </span>
      </>
    )
    
      
    
  );
};

export default InformationCardContentTopSite; 